import { BUTTON_STYLE } from '@elo-kit/constants/contentPage.constants'
import { POSITIONS } from 'constants/embeddableItems.constants'
import { COLORS } from '@elo-kit/constants/general.constants'

import { getFontStyle, getFontWeight, getFontStyles } from '@elo-kit/utils/fonts.utils'
import { cleanupFonts } from 'utils/fonts.utils'

// TODO: update with using createUseStyles
const embeddableItemStyles = (theme) => ({
  marginFix: {
    display: 'inline-block',
  },
  embedFormContainer: {
    padding: 30,
    width: `${theme.embedFormContainerMaxWidth}px`,
    margin: 15,
    position: 'relative',
    '&:before': {
      backgroundColor: theme.embedFormColor,
      opacity: theme.embedFormContainerOpacity / 100,
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'block',
      borderRadius: theme.embedFormContainerRadius,
      boxShadow: `0 6px 20px rgba(0, 0, 0, ${theme.embedFormShadowOpacity / 100})`,
    },
    '@media (max-width: 630px)': {
      width: `${theme.embedFormContainerMaxWidth > 300 ? 300 : theme.embedFormContainerMaxWidth}px`,
    },
  },
  errorContainer: {
    margin: '20px 0px 20px 0px',
  },
  nameInputsContainer: {
    display: 'flex',
  },
  registrationFormContainer: {
    borderTop: `solid 1px ${COLORS.eloGrey20};`,
    position: 'relative',
    paddingTop: theme.labelsEnabled ? '30px' : '40px',
    '& .fas:not(.fa-exclamation-circle)': {
      color: COLORS.eloGrey50,
      fontSize: '18px',
      position: 'absolute',
      right: 0,
      top: 10,
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.8,
      },
    },
  },
  embedFormLabel: {
    fontSize: `${theme.labelSize}px`,
    fontFamily: cleanupFonts(theme.labelFontFamily),
    ...getFontStyles(theme.labelFontStyle),
    fontWeight: getFontWeight(theme.labelFontStyle),
    color: theme.labelColor,
  },
  embedFormResultContainer: {
    marginTop: '30px',
  },
  embedFormAcceptContainer: {
    margin: '30px 0px 30px 0px',
  },
  registrationCta: {
    textAlign: 'center',
    color: theme.regCtaFontColor,
    fontFamily: cleanupFonts(theme.regCtaFontFamily),
    fontSize: '13px',
    lineHeight: 1,
    cursor: 'pointer',
  },
  embedFormHeader: {
    textAlign: 'left',
  },
  embedFormTitle: {
    marginBottom: '30px',
    fontFamily: cleanupFonts(theme.titleFontFamily),
    ...getFontStyles(theme.titleFontStyle),
    fontWeight: getFontWeight(theme.titleFontStyle),
    color: theme.titleFontColor,
    fontSize: `${theme.titleFontSize}px`,
    lineHeight: 1,
  },
  embedFormDescription: {
    fontSize: '12px',
    color: COLORS.eloGrey40,
    lineHeight: 1,
    '&:not(:last-child)': {
      marginBottom: '15px',
    },
  },
  embedFormContent: {
    position: 'relative',
  },
  textLink: {
    fontFamily: cleanupFonts(theme.fontFamily),
    ...getFontStyles(theme.fontStyle),
    fontWeight: getFontWeight(theme.fontStyle),
    color: theme.fontColor,
    fontSize: `${theme.fontSize}px`,
    '&:hover': {
      color: theme.fontColor,
      opacity: 0.8,
    },
  },
  button: {
    background: theme.buttonStyle === BUTTON_STYLE.outlined ? 'none' : theme.buttonColor,
    border: `2px solid ${theme.buttonColor || '#FFB000'}`,
    fontFamily: cleanupFonts(theme.buttonFontFamily),
    ...getFontStyles(theme.buttonFontStyle),
    fontWeight: getFontWeight(theme.buttonFontStyle),
    color: theme.buttonFontColor,
    fontSize: `${theme.buttonFontSize}px`,
    borderRadius: `${theme.buttonBorderRadius}px`,
    lineHeight: 1,
    wordBreak: 'break-word',
    textAlign: 'center',
    padding: '10px 30px',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: theme.buttonHoverColor,
    },
    '&:focus': {
      outline: 'none',
    },
    '&:active': {
      opacity: 0.7,
    },
    '&:disabled': {
      opacity: 0.6,
    },
  },
  slider: {
    padding: '30px 45px',
    margin: '15px',
    position: 'relative',
    display: 'inline-block',
    '&:before': {
      backgroundColor: '#ffffff',
      opacity: theme.sliderBackgroundOpacity / 100,
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'block',
      borderRadius: '4px',
      boxShadow: `0 6px 20px rgba(0, 0, 0, ${theme.sliderShadowOpacity / 100})`,
    },
  },
  backgroundImageContainer: {
    height: 270,
    borderRadius: `${theme.badgeBorderRadius}px ${theme.badgeBorderRadius}px 0 0`,
    backgroundColor: '#efedef',
    color: COLORS.eloWhite,
    fontSize: 85,
    width: '100%',
    display: 'flex',
    '& > div': {
      borderRadius: `${theme.badgeBorderRadius}px ${theme.badgeBorderRadius}px 0 0`,
    },
  },
  boxShadowFix: {
    padding: '15px',
    display: 'inline-block',
  },
  productBackground: {
    padding: '28px 20px',
    background: theme.badgeColor,
    borderRadius: `0 0 ${theme.badgeBorderRadius}px ${theme.badgeBorderRadius}px`,
  },
  productCover: {
    backgroundSize: 'cover',
    width: '100%',
    backgroundPosition: 'center',
  },
  badgeContainer: {
    backgroundColor: theme.badgeColor,
    transition: 'all .2s ease-in-out',
    borderRadius: `${theme.badgeBorderRadius}px`,
    boxShadow: '0 6px 20px 0 rgb(0,0,0,0.15)',
    width: 270,
    position: 'relative',
    display: 'inline-block',
  },
  priceContainer: {
    display: 'block',
    textAlign: 'center',
    lineHeight: 1.2,
    backgroundColor: theme.tagBackground,
    position: 'absolute',
    top: '35px',
    right: '-10px',
    padding: '5px 20px',
    borderRadius: '3px',
  },
  price: {
    fontFamily: cleanupFonts(theme.buttonFontFamily),
    fontSize: '16px',
    fontWeight: 'bold',
    color: theme.tagFontColor,
  },
  productName: {
    marginBottom: '15px',
    wordBreak: 'break-word',
    fontFamily: cleanupFonts(theme.badgeFontFamily),
    fontStyle: getFontStyle(theme.badgeFontStyle),
    fontWeight: getFontWeight(theme.badgeFontStyle),
    color: theme.badgeFontColor,
    fontSize: `${theme.badgeFontSize}px`,
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: POSITIONS[theme.buttonAlignment],
  },
  shadow: {
    '&:hover': {
      '-webkit-box-shadow': '0px 8px 15px 0px rgba(0, 0, 0, 0.25)',
      '-moz-box-shadow': '0px 8px 15px 0px rgba(0, 0, 0, 0.25)',
      transition: 'all 0.4s ease 0s',
    },
  },

  textShadow: {
    '&:hover': {
      textShadow: '0px 0px 6px rgba(255, 255, 255, 1)',
      '-webkit-box-shadow': '0px 8px 15px 0px rgba(0, 0, 0, 0.25)',
      '-moz-box-shadow': '0px 8px 15px 0px rgba(0, 0, 0, 0.25)',
      transition: 'all 0.2s ease 0s',
    },
  },

  transparency: {
    '&:hover': {
      opacity: 0.8,
    },
  },

  stretching: {
    '&:hover': {
      letterSpacing: 3,
      '-webkit-box-shadow': '0px 5px 16px 0px rgba(0, 0, 0, 0.29)',
      '-moz-box-shadow': '0px 5px 16px 0px rgba(0, 0, 0, 0.29)',
      transition: 'all 0.3s ease 0s',
    },
  },

  '@keyframes increasingAnimation': {
    '80%': {
      '-webkit-transform': 'scale(1.2,1.2)',
      transform: 'scale(1.2,1.2)',
    },
  },

  increasing: {
    margin: '0px 15px 0px 15px',
    transition: 'all 0.7s',
    '&:hover': {
      transform: 'scale(1.17,1.17)',
      '-webkit-animation': 'increasingAnimation 0.25s ease',
      animation: 'increasingAnimation 0.25s ease',
      '-webkit-animation-iteration-count': 1,
      'animation-iteration-count': 1,
      animationName: '$increasingAnimation',
    },
  },

  bordering: {
    '&:hover': {
      transition: 'all 0.5s',
      borderRadius: theme.borderRadius === undefined || theme.borderRadius > 0 ? 0 : 30,
    },
  },

  '@keyframes swingAnimation': {
    '15%': {
      '-webkit-transform': 'translateX(5px)',
      transform: 'translateX(5px)',
    },
    '30%': {
      '-webkit-transform': 'translateX(-5px)',
      transform: 'translateX(-5px)',
    },
    '50%': {
      '-webkit-transform': 'translateX(3px)',
      transform: 'translateX(3px)',
    },
    '65%': {
      '-webkit-transform': 'translateX(-3px)',
      transform: 'translateX(-3px)',
    },
    '80%': {
      '-webkit-transform': 'translateX(2px)',
      transform: 'translateX(2px)',
    },
    '100%': {
      '-webkit-transform': 'translateX(0)',
      transform: 'translateX(0)',
    },
  },

  swing: {
    '&:hover': {
      '-webkit-animation': 'swingAnimation 1s ease',
      animation: 'swingAnimation 1s ease',
      '-webkit-animation-iteration-count': 1,
      'animation-iteration-count': 1,
      animationName: '$swingAnimation',
    },
  },

  fillOutlineSwitch: {
    transition: 'all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1) 0s',
    position: 'relative',
    '&:hover': {
      background: theme.style === BUTTON_STYLE.outlined ? theme.buttonColor : 'none',
    },
  },

  coloredShadow: {
    '&:hover': {
      '-webkit-box-shadow': `0px 8px 15px 0px ${theme.buttonColor}`,
      '-moz-box-shadow': `0px 8px 15px 0px ${theme.buttonColor}`,
      transition: 'all 0.4s ease 0s',
    },
  },

  poweredBy: {
    marginTop: 30,
    marginBottom: -20,
    textAlign: 'center',
    color: '#9e9e9e',
    fontSize: 11,
    lineHeight: 1,
  },

  elopageLink: {
    fontSize: 11,
    color: '#ffb000',
    marginLeft: 5,

    '&:hover': {
      opacity: 0.8,
      color: '#ffb000',
    },
  },
})

export default embeddableItemStyles
